import React, { useState, useRef, useEffect } from "react";
import "./index.scss";

const MainDropDown = ({
    className="",
    options,
    placeholder = "Select...",
    onSelect,
    disabled,
    selectedOption,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        if (disabled) {
            return;
        }
        setIsOpen((prev) => !prev);
    };

    const handleOptionClick = (option) => {
        if (option.isDisabled) return; // Prevent selection if the option is disabled
        onSelect(option);
        setIsOpen(false);
    };

    const handleOutsideClick = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const detectTheme = () => {
        return JSON.parse(localStorage.getItem("theme_config"))
            ? JSON.parse(localStorage.getItem("theme_config")).theme
            : "light";
    };

    const selectedOptionItem = options.find((option) => option.value == selectedOption);

    return (
        <div className={`main-dropdown ${className} ${detectTheme()}`} ref={dropdownRef}>
            <div className={`${disabled ? "disabled" : ""}  main-dropdown__header`} onClick={toggleDropdown}>
                {selectedOptionItem ? selectedOptionItem.label : placeholder}
                <span className={`main-dropdown__arrow ${isOpen ? "open" : ""}`}
                >
                    <img
                        src="/down-arrow.svg"
                        alt="Down Arrow"
                        className={`main-dropdown__arrow-icon ${detectTheme() === "light" ? "color-black" : "color-light"}`}
                    />
                </span>
            </div>
            {isOpen && (
                <ul className="main-dropdown__menu">
                    {options.map((option, index) => (
                        <li
                            key={index}
                            className={`main-dropdown__item ${option.isDisabled ? "disabled" : ""}`}
                            onClick={() => handleOptionClick(option)}
                            style={{
                                pointerEvents: option.isDisabled ? "none" : "auto",
                                opacity: option.isDisabled ? 0.5 : 1,
                                backgroundColor: option.isDisabled ? "#E60" : "",
                            }}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default MainDropDown;
